import React from 'react';
var FiltersContext = React.createContext({
  schema: {}
});
export default FiltersContext;